import React from 'react';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

class Title extends React.Component {
  render() {
    return(
      <AppBar position="static">
        <Toolbar>
          <Typography component="h1" variant="h5">What is this movie?</Typography>
        </Toolbar>
      </AppBar>
    );
  }
}

export default Title;